import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
// un comment the below block to enable ignore functionality
/* import { IconMenu, MenuItem } from 'react-toolbox/lib/menu'; */
import { states } from 'constants/DropdownsValues';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import * as action from 'components/DashboardView/actionTypes';


import styles from './SchoolTile.scss';
// to import local scss fle

const SchoolTile = (props) => {
  // console.log('props in schoolTile: ', props);
  const clickToRemoveFromWishList = () => {
    const payload = {
      student_profile_id: props.profileId,
      college_id_index: props.wishListId,
      type_of_list: 'WISHLIST',
      sa_email: props.sa_email,

    };
    props.removeFromList(payload, action.UPDATE_WISHLIST, 'sa_wishlist');
  };
  const clickToAdd = () => {
    const payload = {
      student_profile_id: props.profileId,
      college_id: props.saSchool.get('id'),
      type_of_list: 'WISHLIST',

    };
    props.addToList(payload, action.UPDATE_WISHLIST, 'sa_wishlist');
  };

    // TODO un comment the below block to enable ignore functionality

    /* const clickToIgnore = () => {
      const payload = {
        student_profile_id: props.profileId,
        college_id: props.saSchool.get('id'),
        type_of_list: 'IGNORE',
      };
      props.addToList(payload, action.UPDATE_IGNORELIST, 'sa_ignorelist');
    }; */

  const clickToUnIgnore = () => {
    const payload = {
      student_profile_id: props.profileId,
      college_id_index: props.ignoreListId,
      type_of_list: 'IGNORE',
      sa_email: props.sa_email,

    };
    props.removeFromList(payload, action.UPDATE_IGNORELIST, 'sa_ignorelist');
  };


  const clickToRequest = () => {
    const { subscribed, onTrial } = props;
    const contactedCountMap = props.profile.get('contactedCount');
    // const trialEndDate = props.profile.get('trialEndDate');
    let contactedCount;
    if (contactedCountMap) {
      contactedCount = contactedCountMap.toJS();
    }
    const counter = contactedCount.count; // eslint-disable-line
    // console.log('contactedCount ontrial: ', contactedCount, onTrial);
    // const undefinedCase = props.profile.get('contactedCount');
    // const difference = moment().diff(contactedCount.lastContacted, 'hours');
    const difference = moment().isSame(moment(contactedCount.lastContacted), 'day');
    // eslint-disable-next-line no-console
    // console.log('check', moment().isAfter(contactedCount.lastContacted, 'days'));
    // eslint-disable-next-line no-console
    // console.log('school tile', counter, difference, contactedCount, moment());

    const req = {
      from_profile_id: props.profileId,
      college_id: props.saSchool.get('id'),
      request_type: 'INTEREST',
      college_name: props.saSchool.get('college'),
      college_image: 'https://media.dev.myrecruitboard.com/Images/defaultCollege.png',
      city: props.saSchool.get('city'),
      division: props.saSchool.get('division'),
      sa_name: props.fullname,
      sa_state: states[props.state],
      sa_preference: props.position_pref,
      sa_school: props.school,
      sa_city: props.city,
      sa_image: props.sa_image,
      sa_email: props.sa_email,
      year_of_graduation: props.year_of_graduation,
      team_page_link: props.saSchool.get('football_team_page'),
      question_link: props.saSchool.get('football_questionaire_page'),
      sa_twitter: ((props.profile.get('sa_twitter') !== undefined) && (props.profile.get('sa_twitter') !== null)) ? props.profile.get('sa_twitter').substring('https://twitter.com/'.length) : '',
      sa_height: props.profile.get('height'),
      sa_weight: props.profile.get('weight'),
      sa_t40: props.t40,
      request_views: props.requestViewedCount,
    };

    let maxCount = 1;
    if (subscribed || onTrial) {
      maxCount = 10;
    }

    // if (subscribed) {
    if (counter < maxCount || contactedCountMap === undefined) {
      // console.log('In 1st');
      const payload = {
        student_profile_id: props.profileId,
        college_id: props.saSchool.get('id'),
        type_of_list: 'CONTACTED',
      };
      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');

      if (props.inWishList) {
        clickToRemoveFromWishList();
      }
        props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
      props.showSnackBar('Added to contacted list, will keep you informed.');
    } else if (counter >= maxCount && !difference) {
      // console.log('In 2nd');
      const payload = {
        student_profile_id: props.profileId,
        college_id: props.saSchool.get('id'),
        type_of_list: 'CONTACTED',
      };
      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');

      if (props.inWishList) {
        clickToRemoveFromWishList();
      }
        props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
      props.showSnackBar('Added to contacted list, will keep you informed.');
    } else {
      // console.log('subscribed');
      props.showCounterScreen();
    }
    // }
    // if (onTrial) {
    //   console.log('Ok here in trial if');
    //   if (counter < 10 || contactedCountMap === undefined) {
    //     console.log('In 1st');
    //     const payload = {
    //       student_profile_id: props.profileId,
    //       college_id: props.saSchool.get('id'),
    //       type_of_list: 'CONTACTED',
    //     };
    //     props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');

    //     if (props.inWishList) {
    //       clickToRemoveFromWishList();
    //     }
    //     props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
    //     props.showSnackBar('Added to contacted list, will keep you informed.');
    //   } else if (counter >= 10 && difference >= 4) {
    //     console.log('In 2nd');
    //     const payload = {
    //       student_profile_id: props.profileId,
    //       college_id: props.saSchool.get('id'),
    //       type_of_list: 'CONTACTED',
    //     };
    //     props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
    //     if (props.inWishList) {
    //       clickToRemoveFromWishList();
    //     }
    //     props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
    //     props.showSnackBar('Added to contacted list, will keep you informed.');
    //   } else {
    //     console.log('trial');
    //     props.showCounterScreen();
    //   }
    // }

    // if (!subscribed && (counter < 1 || contactedCountMap === undefined)) {
    //   // eslint-disable-next-line no-debugger
    //   // debugger;
    //   const payload = {
    //     student_profile_id: props.profileId,
    //     college_id: props.saSchool.get('id'),
    //     type_of_list: 'CONTACTED',
    //   };
    //   props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');

    //   if (props.inWishList) {
    //     clickToRemoveFromWishList();
    //   }
    //   props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
    //   props.showSnackBar('Added to contacted list, will keep you informed.');
    // } else if (!subscribed && (counter >= 1 && difference >= 5)) {
    //   // eslint-disable-next-line no-debugger
    //   // debugger;
    //   const payload = {
    //     student_profile_id: props.profileId,
    //     college_id: props.saSchool.get('id'),
    //     type_of_list: 'CONTACTED',
    //   };
    //   props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
    //   if (props.inWishList) {
    //     clickToRemoveFromWishList();
    //   }
    //   props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
    //   props.showSnackBar('Added to contacted list, will keep you informed.');
    // } else if (!subscribed && !onTrial) {
    //   console.log('free');
    //   props.showCounterScreen();
    // }
  };

  // const handleRequest = () => {
  //   const counter = parseInt(props.syncData.get('count')); // eslint-disable-line
  //   const difference = moment().diff(props.syncData.get('lastModified'), 'minutes');
  //   console.log('difference', difference);
  //   if (counter < 2) {
  //     clickToRequest;
  //   } else if (counter === 2 && difference > 1) {
  //     clickToRequest;
  //   } else {
  //     props.showCounterScreen();
  //   }
  // };

  const renderIfIgnored = renderIf(props.ignoreListId === -1);
  const renderIfUnIgnored = renderIf(props.ignoreListId >= 0);
  const showDefaultStatus = props.fillQ || props.inviteToCamp || props.interested;
  const renderDefaultStatus = renderIf(showDefaultStatus);

  const renderFillQ = renderIf(props.fillQ && !props.inviteToCamp);
  const renderInviteToCamp = renderIf(props.inviteToCamp);
  let renderJuco = false;
  if (props.saSchool.get('division') === 'SCFA' || props.saSchool.get('division') === 'NJCAA' ||
      props.saSchool.get('division') === 'CCCAA') {
    renderJuco = true;
  }

  // const trialEndDate = props.profile.get('trialEndDate');
  // console.log('trialdate', trialEndDate);

  return (
    <div className={styles.container}>
      <img className={styles.hide} src="https://media.dev.myrecruitboard.com/Images/heart-full.png" alt="heartIcon" />

      <div className={styles.tile}>
        {/* eslint-disable */}

              {renderIfIgnored(
                  <span>
              {
                  props.inWishList ?
                      <a href="javascript:void(0)" title="Add to wishList" onClick={clickToRemoveFromWishList}>
                        <img className={styles.heartIcon} src="https://media.dev.myrecruitboard.com/Images/heart-full.png" alt="heartIcon" />
                      </a>
                      :
                      <a href="javascript:void(0)" title="Add to wishList" onClick={clickToAdd}>
                        <img className={styles.heartIcon} src="https://media.dev.myrecruitboard.com/Images/hearIcon.png" alt="heartIcon" />
                      </a>
              }
              </span>
              )}

            <img className={styles.colgeIcon} src="https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png" alt="college-icon" />
            <div className={props.usedFor === 'schools' ? styles.collegeName : styles.collegeNameOnWishList}>
                <a href={props.saSchool.get('football_team_page')} target="_blank">
                    {props.saSchool.get('college')}
                </a><br/>
            <span className={styles.lightText}>{props.saSchool.get('city')}</span><br />
            <span className={styles.lightText}>
                {props.saSchool.get('state') === 'D.C.' ? 'Washington D.C' : props.saSchool.get('state') }
                </span>
            </div>{props.usedFor === 'schools' ? '' : <br />}
              {renderJuco === true ?
                <span className={styles.lightText}>JUCO</span>
                :
                <span className={styles.lightText}>{props.saSchool.get('division')}</span>
               }
            <div className={props.usedFor === 'schools' ? styles.veryLightTextt : styles.veryLightTextWithHeight }>
                {renderDefaultStatus(
                    <span>
                  Awaiting Response
                </span>
                )}
                {renderFillQ(
                    <span>Fill Questionaire</span>
                )}
                {renderInviteToCamp(
                    <span>Invited to Camp</span>
                )}
            </div>

              {renderIfUnIgnored(<div className={styles.tileFooter}>
              <span className={styles.unignore} onClick={clickToUnIgnore}>
                UNIGNORE
                </span>
                  </div>
              )}

              {renderIfIgnored(
                  <div className={props.interested? styles.coloredTileFooter : styles.tileFooter}>
                      { props.interested ? <span>INTERESTED</span> :
                          <span className={styles.clickable} onClick={() => clickToRequest()}>
                        CONTACT COACH
                        </span>
                      }
                    <span className={styles.dotIcons}>
                    </span>
                  </div>)}
          </div>
            {/* eslint-enable */}
    </div>
  );
};

SchoolTile.propTypes = {
  saSchool: PropTypes.shape().isRequired,
  inWishList: PropTypes.bool,
  inviteToCamp: PropTypes.bool,
  fillQ: PropTypes.bool,
  profileId: PropTypes.string.isRequired,
  fullname: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  position_pref: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  sa_image: PropTypes.string.isRequired,
  school: PropTypes.string.isRequired,
  addToList: PropTypes.func.isRequired,
  addToRequest: PropTypes.func.isRequired,
  interested: PropTypes.bool,
  wishListId: PropTypes.number,// eslint-disable-line
  removeFromList: PropTypes.func.isRequired, // eslint-disable-line
  ignoreListId: PropTypes.number,
  showSnackBar: PropTypes.func.isRequired,
  sa_email: PropTypes.string.isRequired,
  profile: PropTypes.shape(), // eslint-disable-line
  showCounterScreen: PropTypes.func.isRequired,
  year_of_graduation: PropTypes.string.isRequired,
  t40: PropTypes.string.isRequired,
  requestViewedCount: PropTypes.number.isRequired,
};

SchoolTile.defaultProps = {
  inWishList: false,
  interested: false,
  wishListId: -1,
  ignoreListId: -1,
  inviteToCamp: false,
  fillQ: false,
  user: {},
 // syncData: {},
};

export default SchoolTile;



// WEBPACK FOOTER //
// ./src/components/SchoolTile/SchoolTile.js